module.exports = __webpack_public_path__ + "assets/img/thumb-Earlytrade-Social-Static-Ad.cc85d75f.jpg";